<!-- 0元试用 -->
<template>
  <div class="createPlayStep new-input-box">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="returnBack()"
        >返回</jd-button
      >
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStepNum != 99 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStepNum == 99">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                @click="handleNav(item, index)"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == tabActive }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid #d4e2ff"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: #eaf1ff"
                ></div>
              </div>
              <!-- hover -->
              <div
                class="temImg_content_bgshadow"
                style="height: 432px; border-radius: 8px"
                @click="handleOpen()"
              >
                <div class="temImg_content_bgshadow_codeDZ">
                  <img
                    style="width: 100%"
                    src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div
              class="temImg"
              v-for="(item, index) in giftList"
              :key="item.id"
            >
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    class="imgs"
                    style="width: 100%"
                    :src="item.imageUrl"
                    alt=""
                  />
                  <img
                    v-if="item.days"
                    class="temImg_content_img_free"
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/common/free.svg"
                    alt=""
                    srcset=""
                  />
                  <div v-if="item.days" class="temImg_content_img_time">
                    倒计时：{{ item.days }}
                  </div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="queryId"
                  ref="queryId"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStepKai(index + 1, item.id)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <informationForm 
            v-model="ruleForm"
            needNonMember
            :defaultActivityStartTime="ruleForm.startTime"
            :defaultActivityEndTime="ruleForm.endTime"
            :defaultActMember.sync="actMember"
            :plusObject.sync="ruleDto.plusObject"
            :openCardStartTime.sync="ruleDto.openCardStartTime"
            :openCardEndTime.sync="ruleDto.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            :disabled="activityData.isStart"
            @selectPeopleSure="selectPeopleSure"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          />
          <!-- <jd-title label="基本信息" type="bold"></jd-title>
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              :disabled="backgroundOpacity"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.startTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange($event, 1)"
                :picker-options="pickerOptionsValue"
                :clearable="false"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :disabled="activityData.isStart || backgroundOpacity"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.endTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange($event, 2)"
                @focus="orderFocus"
                :picker-options="pickerOptionsValueEnd"
                :clearable="false"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :disabled="activityData.isStart || backgroundOpacity"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart && !backgroundOpacity"
                @click="clearTime()"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2768ff">{{ timeDay }}</span> 天
              <span style="color: #2768ff">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动有效期不可超过订购有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
            <div class="act-tip" v-if="isShowTip">
              *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
            </div>
          </el-form-item>
          <el-form-item label="活动对象:" prop="partner">
            <el-radio
              v-model="actMember"
              label="1"
              :disabled="activityData.isStart || backgroundOpacity"
              >不限</el-radio
            >
            <el-radio
              v-model="actMember"
              label="2"
              :disabled="activityData.isStart || backgroundOpacity"
              >会员身份</el-radio
            >
            <el-radio
              v-model="actMember"
              label="3"
              :disabled="activityData.isStart || backgroundOpacity || softType == 1"
              >指定人群
              <el-button
                style="margin-left: 10px"
                v-if="actMember == '3'"
                :disabled="activityData.isStart"
                @click="openCrowd"
                >已选人群({{ peopleSelected.length }})</el-button
              >
            </el-radio>
            <div v-if="actMember == '2'" class="flexc-cen-x">
              <el-checkbox-group
                v-model="ruleDto.partner"
                @change="checkListchange"
                :disabled="activityData.isStart || backgroundOpacity"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <el-checkbox
                  label="0"
                  name="partner"
                  :disabled="ruleDto.partner == -1"
                  >非会员</el-checkbox
                >
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleDto.partner == -1"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </div>

            <div v-if="actMember == '2'" class="flexc-cen-x">
              <span>入会时间：</span>
              <el-checkbox
                v-model="ruleDto.isCheckOpenCardTime"
                :disabled="activityData.isStart || backgroundOpacity"
                >指定时间段</el-checkbox
              >
              <div class="my_select_time" style="margin-left: 8px">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime ||
                    activityData.isStart ||
                    backgroundOpacity
                  "
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardEndTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  :picker-options="openCardEndTimeOptionsValue"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime ||
                    activityData.isStart ||
                    backgroundOpacity
                  "
                >
                </el-date-picker>
                <i
                  v-if="!activityData.isStart && !backgroundOpacity"
                  class="el-icon-circle-close date_icon1"
                  @click="clearNewTime"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
            </div>
            <span v-if="actMember == '2'" style="color: #f56c6c"
              >注意：该条件对【非会员】身份不生效</span
            >
          </el-form-item>

          <el-form-item label="Plus会员身份:" required>
            <el-radio
              v-model="ruleDto.plusObject"
              :label="0"
              :disabled="activityData.isStart || backgroundOpacity"
              >不限</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="1"
              :disabled="activityData.isStart || backgroundOpacity"
              >Plus会员</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="2"
              :disabled="activityData.isStart || backgroundOpacity"
              >非plus会员</el-radio
            >
            <div style="color: #f56c6c">
              注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
            </div>
          </el-form-item>

          <el-form-item label="活动条件:">
            <el-checkbox
              label="关注店铺后方可参与活动"
              v-model="ruleForm.condFollow"
              :true-label="1"
              :false-label="0"
              :disabled="backgroundOpacity"
            ></el-checkbox>
          </el-form-item> -->

          <jd-title label="活动设置" type="bold"></jd-title>
          <el-form-item label="报名时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleDto.applyTimeStart"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                :picker-options="pickerOptionsApplyStart"
                :clearable="false"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :disabled="activityData.isStart || backgroundOpacity"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleDto.applyTimeEnd"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @focus="orderFocus"
                :picker-options="pickerOptionsApplyEnd"
                :clearable="false"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :disabled="activityData.isStart || backgroundOpacity"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart && !backgroundOpacity"
                @click="clearApplyTime()"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span style="margin-left: 8px">期间内报名</span>
          </el-form-item>
          <el-form-item label="是否收集试用报告:" required>
            <el-radio
              :disabled="activityData.isStart"
              v-model="trialReport.isCollectTrial"
              :label="0"
            >
              <span class="radioItem">无需收集</span></el-radio
            >
            <el-radio
              :disabled="activityData.isStart"
              v-model="trialReport.isCollectTrial"
              :label="1"
            >
              <span class="radioItem"
                >需要收集（选此项则用户申请试用后，需要填写试用报告）</span
              ></el-radio
            >
            <setTopic
              v-if="trialReport.isCollectTrial === 1"
              @collectQuestion="collectQuestion"
              :questions="trialReport.questions"
              :isStart="activityData.isStart"
              :isReadOnly="backgroundOpacity"
              :limitNum="10"
              labelWidth="0px"
              labelName=""
            ></setTopic>
          </el-form-item>
            <el-form-item label="试用报告是否显示C端:" required>
               <el-radio
              :disabled="activityData.isStart"
               v-model="trialReport.isReportDisplayC"
              :label="1"
            >
              <span class="radioItem">是（用户填写完成报告后自动显示于C端）</span></el-radio
            >
            <el-radio
              :disabled="activityData.isStart"
               v-model="trialReport.isReportDisplayC"
              :label="0"
            >
              <span class="radioItem"
                >否</span
              ></el-radio
            >
            </el-form-item>
          <el-form-item label="试用商品：" required>
            <jd-button
              @click="addProduct"
              :disabled="activityData.isStart || backgroundOpacity"
              >添加商品</jd-button
            >
            <div
              class="trialdatalist"
              v-if="ruleForm.pointActivityPrizeDTOList.length"
            >
              <div
                v-for="(trial, index) in ruleForm.pointActivityPrizeDTOList"
                :key="index"
                class="trialdata"
                :style="{width: activityData.isStart && !backgroundOpacity ?  '650px' : '650px'}"
              >
                <div
                  class="trialdataitem"
                  style="display: flex; align-items: center"
                >
                  <span class="label">奖品名称：</span>
                  <span class="name">{{ trial.title }}</span>
                  <span class="trbuttons">
                    <div
                      class="trbutton"
                      @click="trialTop(index)"
                      :class="[
                        (!backgroundOpacity && index == 0) ||
                        activityData.isStart ||
                        backgroundOpacity
                          ? 'disabled'
                          : '',
                      ]"
                    >
                      上移
                    </div>
                    <div
                      class="trbutton"
                      @click="trialBottom(index)"
                      :class="[
                        (!backgroundOpacity &&
                          index ==
                            ruleForm.pointActivityPrizeDTOList.length - 1) ||
                        activityData.isStart ||
                        backgroundOpacity
                          ? 'disabled'
                          : '',
                      ]"
                    >
                      下移
                    </div>
                    <div
                      class="trbutton"
                      @click="trialEdit(index)"
                      :class="[
                        activityData.isStart || backgroundOpacity
                          ? 'disabled'
                          : '',
                      ]"
                    >
                      编辑
                    </div>
                    <div
                      class="trbutton"
                      @click="trialRemove(index)"
                      :class="[
                        activityData.isStart || backgroundOpacity
                          ? 'disabled'
                          : '',
                      ]"
                    >
                      删除
                    </div>
                    <div
                      class="trbutton1"
                      @click="addPrizeNumFn(trial,index)"
                      v-if="activityData.isStart && !backgroundOpacity"
                    >
                      增加库存
                    </div>
                  </span>
                </div>
                <div class="trialdataitem" style="display: flex">
                  <span class="label">奖品图片：</span>
                  <img :src="trial.logo" width="50" height="50" />
                </div>
                <div class="trialdataitem">
                  <span class="label">奖品价值：</span>
                  {{ trial.price }}元
                </div>
                <div class="trialdataitem">
                  <span class="label">试用方式：</span>
                  {{
                    trial.tryWay == 0
                      ? "0元试用"
                      : `积分试用，消耗${trial.needPointAmount}积分获得试用报名机会`
                  }}
                </div>
                <div class="trialdataitem">
                  <span class="label">开奖方式：</span>
                  {{ trial.rewardWayPreview }}
                </div>
                <!-- 1.62 -->
                  <div  class="trialdataitem" v-if="trial.rewardWay == '2'" style="display: block; 
                    padding: 10px;
                    margin-top: 10px;
                    font-size: 12px;
                    background-color: #fdf5e6;">
                  <div class="label">中奖条件（不勾选则不限制）</div>
                  <el-checkbox :disabled="true" v-model="trial.onlyConsumeUser">仅抽取报名参与且在店内消费大于 
                  <el-input :disabled="true" v-model="trial.trialConsumeAmount" :min="0" :step="10" style="width: 80px; margin: 0 10px;"></el-input> 元的用户（如参与用户中无消费则不中奖）</el-checkbox>
                  </div>
                <div class="trialdataitem">
                  <span class="label">收货地址填写截止时间：</span>
                  {{ trial.addressFillEndTime }}
                </div>
                <div class="trialdataitem">
                  <span class="label">奖品份数：</span>
                  {{ trial.totalAmount }}份
                </div>
                <div class="trialdataitem">
                  <span class="label">开奖时间：</span>
                  {{ trial.awardTime }}
                </div>
                <div class="trialdataitem">
                  <span class="label">是否需要输入申请理由：</span>
                  {{ trial.reasonFillFlag ? "是" : "否" }}
                </div>
              </div>
            </div>
          </el-form-item>
          <jd-title label="配置页设置" type="bold"></jd-title>
          <el-form-item label="中奖名单显示：">
            <el-radio-group
              :disabled="backgroundOpacity"
              v-model="ruleDto.winningListType"
            >
              <el-radio :label="0">不显示</el-radio>
              <el-radio :label="1"
                >显示（C端小程序开启显示中奖名单信息）</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <activityPageSettings 
            isShowShopName
            isShowMoreSet
            v-model="ruleDto"
            defaultTitleKey="activityTheme"
            defaultDescKey="activityRemark"
            defaultTitleColorKey="textColor"
            :giftList="giftList"
            :templateId="templateId"
            :widthNumber="750"
            :heightNumber="1740"
            :cusTemplateJSON.sync="ruleDto.cusTemplateJSON"
            @selectTemplate="templateId = giftList[$event].id"
            :designSpecificationsUrl="designSpecificationsList[activityData.id]"
          />
          <!-- <jd-title label="活动页设置" type="bold"></jd-title>
          <el-form-item label="活动标题:">
            <el-input
              v-model="ruleDto.activityTheme"
              maxlength="10"
              show-word-limit
              placeholder="请输入"
              style="width: 400px"
              :disabled="backgroundOpacity"
            ></el-input>
            <el-tooltip
              class="item"
              effect="light"
              content="不填则C端不显示"
              placement="top"
            >
              <el-button type="text" style="width: 35px">
                <i class="el-icon-question grey-style"></i>
              </el-button>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="活动说明:">
            <el-input
              v-model="ruleDto.activityRemark"
              maxlength="25"
              show-word-limit
              placeholder="请输入"
              style="width: 400px"
              :disabled="backgroundOpacity"
            ></el-input>
            <el-tooltip
              class="item"
              effect="light"
              content="不填则C端不显示"
              placement="top"
            >
              <el-button type="text" style="width: 35px">
                <i class="el-icon-question grey-style"></i>
              </el-button>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="标题文字颜色:">
            <div class="flexc-cen-x">
              <el-color-picker
                v-model="ruleDto.textColor"
                size="small"
                class="no-clear-btn"
                :disabled="backgroundOpacity"
              ></el-color-picker>
              <jd-button
                type="blueText"
                style="margin-left: 12px"
                @click="ruleDto.textColor = '#000000'"
                :disabled="backgroundOpacity"
                >重置</jd-button
              >
            </div>
          </el-form-item> -->
          <exposureList 
            v-model="itemListFor"
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
          />
          <!-- <jd-title label="曝光商品" type="bold"></jd-title>
          <el-form-item label="曝光商品:">
            <el-checkbox
              :true-label="1"
              :false-label="0"
              v-model="ruleForm.isExposureItem"
              @change="exposureSwitchChange"
              :disabled="backgroundOpacity"
            >
              是否添加曝光商品
            </el-checkbox>
            <jd-button
              style="margin: 0 16px"
              @click="exposureProducts"
              :disabled="ruleForm.isExposureItem == 0 || backgroundOpacity"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </jd-button>
            <el-radio-group
              v-model="ruleForm.priceType"
              :disabled="ruleForm.isExposureItem == 0 || backgroundOpacity"
            >
              <el-radio :label="0">显示京东价</el-radio>
            </el-radio-group>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px;
              "
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                  :class="backgroundOpacity ? 'unmover' : ''"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible" v-if="!backgroundOpacity">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item> -->
          <sharFrom 
            v-model="ruleDto"
            :sharePic="sharePic"
          />
          <!-- <jd-title label="分享设置" type="bold"></jd-title>
          <el-form-item label="小程序分享标题:" required>
            <el-input
              type="text"
              style="width: 400px"
              show-word-limit
              v-model="ruleDto.shareTitle"
              :maxlength="28"
              @input="inp"
              :disabled="backgroundOpacity"
            ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享简介:" required>
            <el-input
              type="text"
              style="width: 400px"
              show-word-limit
              v-model="ruleDto.shareIntroduce"
              :maxlength="28"
              @input="inp"
              :disabled="backgroundOpacity"
            ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享图片:" required>
            <div class="miniAppPic">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload1"
                  :on-success="handleUpload1"
                  :disabled="backgroundOpacity"
                >
                  <jd-button
                    type="blue"
                    :disabled="backgroundOpacity"
                    >自定义上传</jd-button
                  >
                </el-upload>
                <jd-button
                  type="blueText"
                  class="ml12"
                  :disabled="backgroundOpacity"
                  @click="picUrlReset1"
                  >重置</jd-button
                >
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="ruleDto.sharePic" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：200px * 200px</p>
                  <p>图片大小：1MB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item> -->
          <activityRules 
            v-model="ruleForm.ruleDescription"
            :isForceRemind.sync="ruleDto.isForceRemind"
            :isKeyActivity.sync="isKeyActivity" 
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          />
          <!-- <jd-title label="活动规则" type="bold"></jd-title>
          <el-form-item label="规则内容:" required>
            <div style="width: 570px; position: relative">
              <el-input
                maxlength="2000"
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.ruleDescription"
                :disabled="backgroundOpacity"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.ruleDescription.length
                    ? ruleForm.ruleDescription.length
                    : 0
                }}/2000）
              </div>

              <div>
                <jd-button
                  :disabled="backgroundOpacity"
                  class="margin-t16"
                  type="blue"
                  @click="generateRule"
                  >生成规则</jd-button
                >
                <div class="rule-tip">
                  <jd-tip color="gley">
                    提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                  </jd-tip>
                </div>
              </div>
            </div>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum != 99">
      <jd-button
        v-show="!itemId && backgroundOpacity"
        @click="clickLocalStep()"
        style="margin-right: 8px"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          @click="resetForm"
          v-preventReClick
          type="break"
          >保存设置</jd-button
        >
      </template>

      <jd-button
        v-show="itemId"
        size="medium"
        @click="cancelEdit"
        style="margin-right: 8px"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="break">保存设置</jd-button>
    </div>

    <!-- 选择人群弹窗 -->
    <selectPeople
      v-if="selectPeopleShow"
      :dialogVisible="selectPeopleShow"
      :peopleList="peopleList"
      @confim="selectPeopleSure"
      @close="selectPeopleShow = false"
    ></selectPeople>

    <!-- 试用商品弹窗 -->
    <trial-select
      v-if="trialSelectDialogVisible"
      :trialData="trialData"
      :visible.sync="trialSelectDialogVisible"
      :activityEndTime="ruleForm.endTime"
      :applyTimeStart="ruleDto.applyTimeStart"
      :applyTimeEnd="ruleDto.applyTimeEnd"
      :valueRow="valueRow"
      @submit="trialSelectDone"
      @clearIndex="editSelectIndex = null"
    />

    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button @click="handleDialogCloseAnoth()" type="break"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import informationForm from "./components/informationForm.vue"
import activityPageSettings from "./components/activityPageSettings.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityRules from "./components/activityRules.vue"
import {
  createTrialActivity,
  getTrialActivityDetail,
  hdTaskTemplateGroup,
  sellerImage,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";
import selectPeople from "@/components/select-people-yunqi.vue";
import setTopic from "./components/setTopic/index.vue";
import trialSelect from "./components/trial_select.vue";
import addPrizeNum from "./components/add-prize-num.vue";
import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

export default {
  components: {
    selectGoodsMonitor,
    draggable,
    selectPeople,
    setTopic,
    trialSelect,
    addPrizeNum,
    informationForm,
    activityPageSettings,
    exposureList,
    sharFrom,
    activityRules
  },
  provide() {
    return {
      isShowMatrix: false,
      isShowMoreSelect: false,
    };
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
  },
  watch: {
    localStepNum(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
    actMember(newVal,oldVal) {
      if(newVal!='2') {
        this.ruleDto.openCardStartTime = ""
        this.ruleDto.openCardEndTime = ""
      }
      if(newVal!='3') {
        this.peopleSelected = []
      }
    }
  },
  data() {
    return {
      customerPaperwork: {},
      currentIndex: 0,
      isShowAddNum: false,
      toAddItem: null,
      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      actEndTime: "",
      isShowTip: false,
      // 1.14迭代
      ruleDto: {
        openCardStartTime: "",
        openCardEndTime: "",
        plusObject: 0, //plus会员
        winningListType: 0,
        applyTimeStart: "",
        applyTimeEnd: "",
        partner: ["-1"],
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        activityTheme: "0元试用",
        activityRemark: "定时抽好礼·惊喜享不停",
        textColor: "#000000",
        cusTemplateJSON: "",
        isForceRemind: false,
      },
      isKeyActivity: 0,
      placementPosition: [],
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.ruleDto.openCardEndTime).valueOf() -
                24 * 60 * 60 * 1000
          );
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf()
          );
        },
      },
      mainImagelist: [],
      templateId: "",
      tabActive: 0,
      navItem: {},
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      selectGoodsArr: [],
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() < new Date(this.ruleForm.startTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsApplyStart: {
        disabledDate: (time) => {
          if (this.ruleDto.applyTimeEnd) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > new Date(this.ruleDto.applyTimeEnd).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsApplyEnd: {
        disabledDate: (time) => {
          if (this.ruleDto.applyTimeStart) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() <
                new Date(this.ruleDto.applyTimeStart).valueOf() ||
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      localStepNum: 0, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        isExposureItem: 0,
        priceType: 0,
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: 0,
        ruleDescription: "",
        pointActivityPrizeDTOList: [],
        partner: ["-1"],
        firstOpenCardTimeType: 0,
        openCardBeforeDay: "",
        openCardFollow: 0,
        isValidBlackList: 0,
      },
      trialData: {},
      sharePic: "",
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      disableTime: false,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      uploadSize: false,
      isDraft: false,
      // 试用报告
      trialReport: {
        isCollectTrial: 0,
        questions: [],
        isReportDisplayC: 0,
      },
      trialSelectDialogVisible: false,
    };
  },
  async created() {
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.ruleDto.sharePic = this.sharePic;
    this.ruleDto.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDto.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
    if (this.localStepNum == 0) {
      this.hdTaskTemplateGroup();
    }
    await this.getLevel();
  },
  methods: {
    addPrizeNumFn(row,index) {
      this.currentIndex = index
      this.toAddItem = {
        ...row,
        num: row.totalAmount,
      };
      this.isShowAddNum = true;
    },
    // 改变数量值
    confirmAdd(num) {
      this.ruleForm.pointActivityPrizeDTOList[this.currentIndex].totalAmount = num
      this.isShowAddNum = false;
    },
    calcRewardWay(item) {
      let preview = "";
      switch (item.rewardWay) {
        case 0:
          preview = "手动审核开奖";
          break;
        case 1:
          preview =
            "手动审核开奖，若开奖时间前，手动标记中奖人数为0，则开奖时间后不限制参与人数随机分配中奖";
          break;
        case 2:
          preview = "开奖时间后不限制参与人数随机分配中奖";
          break;
        case 3:
          preview = `每${
            item.personNumOnePrize
          }人报名可中奖1份奖品，最多不超过试用奖品份数，低于${
            item.minPersonNum
          }人报名时${item.rewardFlag == 0 ? "不中奖" : "中奖一份"}`;
          break;
        default:
          break;
      }
      return preview;
    },
    // 初始化默认时间
    getApplyTime() {
      let times = this.$getDate(30);
      let seventyTwoTime = 72 * 60 * 60 * 1000;
      let applyTimeEnd = this.moment(
        new Date(times[1]).valueOf() - seventyTwoTime
      ).format("YYYY-MM-DD HH:mm:ss");
      this.ruleDto.applyTimeStart = times[0];
      this.ruleDto.applyTimeEnd = applyTimeEnd;
    },
    // 打开选择人群
    openCrowd() {
      this.peopleList = this.peopleSelected.map((item) => {
        return { id: item };
      });
      this.selectPeopleShow = true;
      this.actMember = "3";
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
      this.selectPeopleShow = false;
    },
    // 点击下单时间显示提示
    orderFocus() {
      if (this.activityData.isStart) {
        this.isShowTip = true;
      }
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },

    inp(val) {
      this.$forceUpdate();
    },
    //上传图片前校验 分享设置
    beforeUpload1(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 200;
        let height = 200;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          // let valid = width === this.width && height === this.height;
          // 去除尺寸检验
          let valid = true;
          valid ? resolve() : reject(this);
          _this.uploadSize = valid;
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message.info("图片宽高不符合要求,请重新上传");
          return Promise.reject();
        }
      ); 
      // 校验尺寸和类型
      const isLt1M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isType = sorts.includes(type);
      if (!isLt1M) {
        this.$message.info("上传图片大小不能超过 1MB");
      }
      if (!isType) {
        this.$message.info("所选文件格式不符，请重新选择");
      }
      return isLt1M && isType && isSize;
    },
    // 上传成功 分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (this.uploadSize) {
          this.ruleDto.sharePic = res.data;
          this.$forceUpdate();
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      this.ruleDto.sharePic = this.sharePic;
      this.$forceUpdate();
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true;
        item.title = item.groupName;
      });
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      if(!(this.valueRow && this.valueRow.id)) {
        this.templateId = this.giftList[0].id;
      }
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
    },

    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },

    selectGoodsClose(data) {
      if (data) {
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemListFor;
      }
      this.selectGoodsState = false;
    },

    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$forceUpdate();
    },

    nextStepKai(index, templateId = 0) {
      this.localStepNum = 1;
      this.templateJson.templateUItype = index;
      if (templateId) {
        this.templateId = templateId;
      }
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          // 获取详情
          this.getDetail();
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleDto.partner = ["-1"];
        }
      });
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=";
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          text: url + this.giftList[index].imageUrl,
        });
      }
    },
    //生成规则
    generateRule() {
      let text1 = "请在申请结果公布后返回活动页查看开奖情况，如有中奖，需在有效期内填写收货地址信息或完成指定领奖操作，逾期可能导致奖品失效~",
        text2 = `会员在${this.ruleDto.applyTimeStart}~${this.ruleDto.applyTimeEnd}时间段内报名申请试用`,
        text3 = "报名成功后需在收货地址填写截止时间之前提交收货地址信息。",
        text4 = "报名成功之后，需按要求预留收货地址，必须于活指定时间前完成填写，逾期视为放弃领奖资格。",
        text5 = "每个试用奖品都将在指定时间节点，采取系统随机的方式进行抽取中奖人。",
        text6 = "",
        text7 = "（1）用户中奖后，会通过弹窗的形式收集中奖用户的姓名、联系电话、详细地址，实物奖品采取寄送方式发放；\n（2）如出现下列情况，实物奖品将不予发放：① 因用户原因无法取得联系；② 用户未填写真实有效的信息或填写收货信息不详；③ 存在多个用户填写相同中奖人信息，则系统判自动判定为恶意刷奖行为；④超过有效期未填写地址视为放弃；",
        secondText = "\n二、【活动奖品】",
        thirdText = "\n三、【活动参与方式】",
        fourthText = "\n四、【如何获奖】",
        fifthText = "\n五、【奖品发放】\n",
        siveText = "\n六、【注意事项】";
        const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember)

      if (this.ruleForm.pointActivityPrizeDTOList.length) {
        text6 = "试用商品信息：" + "\n";
        let text = "";
        this.ruleForm.pointActivityPrizeDTOList.forEach((item, index) => {
          text +=
            `（${index + 1}）${item.title}，试用份数${
              item.totalAmount
            }，开奖时间${item.awardTime}` +
            `${
              this.ruleForm.pointActivityPrizeDTOList.length == index + 1
                ? ""
                : "\n"
            }`;
        });
        text6 = text6 + text;
      }
      fifthText+=text7;

      let Arr1 = [
        firstText,
        [secondText, text6,text1],
        [thirdText, text2,text3],
        [fourthText, text4,text5],
        [fifthText],
        [siveText,precautions]
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText;
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    initTime() {
      let flag = false;
      let flag1 = false;
      let flag2 = false;
      let flag3 = false;
      flag = this.ruleForm.pointActivityPrizeDTOList.some((item) => {
        return (
          new Date(this.ruleForm.endTime).getTime() <
          new Date(item.awardTime).getTime()
        );
      });
      flag1 = this.ruleForm.pointActivityPrizeDTOList.some((item) => {
        return (
          new Date(this.ruleDto.applyTimeEnd).getTime() >
          new Date(item.awardTime).getTime()
        );
      });
      flag2 = this.ruleForm.pointActivityPrizeDTOList.some((item) => {
        return (
          new Date(this.ruleDto.applyTimeStart).getTime() >
          new Date(item.addressFillEndTime).getTime()
        );
      });
      flag3 = this.ruleForm.pointActivityPrizeDTOList.some((item) => {
        return (
          new Date(this.ruleForm.endTime).getTime() <
          new Date(item.addressFillEndTime).getTime()
        );
      });
      if (flag) {
        this.$message.warning("开奖时间不能大于活动结束时间");
        return false;
      }
      if (flag1) {
        this.$message.warning("开奖时间不能小于报名结束时间");
        return false;
      }
      if (flag1) {
        this.$message.warning("开奖时间不能大于活动结束时间");
        return false;
      }
      if (flag2) {
        this.$message.warning("收货信息填写时间不能小于报名开始时间");
        return false;
      }
      if (flag3) {
        this.$message.warning("收货信息填写时间不能大于活动结束时间");
        return false;
      }

      return true;
    },
    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      // 活动参与对象
      if(this.actMember == 2) {
        if (this.ruleForm.partner.length == 0) {
          this.$message.warning("请选择活动对象");
          return;
        }
        // 1.14迭代 这里判断
        if (
            this.ruleForm.firstOpenCardTimeType==1 &&!this.ruleForm.openCardBeforeDay
          ) {
            this.$message.warning("请完善首次入会时间");
            return;
          }
        if (
          this.ruleForm.firstOpenCardTimeType==2 &&
          (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
      }

      //报名时间：
      if (!this.ruleDto.applyTimeStart || !this.ruleDto.applyTimeEnd) {
        this.$message.warning("请选择报名开始时间");
        return;
      }

      if (
        new Date(this.ruleForm.startTime).getTime() >
          new Date(this.ruleDto.applyTimeStart).getTime() ||
        new Date(this.ruleForm.end).getTime() <
          new Date(this.ruleDto.applyTimeEnd).getTime()
      ) {
        this.$message.warning("报名时间需在活动时间范围内");
        return;
      }

      // 试用商品
      if (
        this.ruleForm.pointActivityPrizeDTOList &&
        !this.ruleForm.pointActivityPrizeDTOList.length
      ) {
        this.$message.warning("请选择试用商品");
        return;
      }
      if (!this.initTime()) {
        return; // 如果时间校验失败，直接返回
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }

      // 小程序分享标题
      if (!this.ruleDto.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDto.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO = {};
      // 活动对象
      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel = this.ruleForm.partner.join(",");
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
        // 入会时间
        obj.ruleDTO.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType;
        obj.ruleDTO.openCardStartTime = this.ruleDto.openCardStartTime;
        obj.ruleDTO.openCardEndTime = this.ruleDto.openCardEndTime;
        obj.ruleDTO.openCardBeforeDay = this.ruleForm.openCardBeforeDay;
      }
      obj.ruleDTO.openCardFollow = this.ruleForm.openCardFollow;
      //关注店铺后方可参与互动
      // obj.ruleDTO.condFollow = Number(this.ruleForm.condFollow);
      // 中奖名单显示
      obj.ruleDTO.winningListType = Number(this.ruleDto.winningListType);
      // 自定义背景图
      obj.ruleDTO.cusTemplateJSON = this.ruleDto.cusTemplateJSON;
      // 强提醒
      obj.ruleDTO.isForceRemind = this.ruleDto.isForceRemind;
      // 是否重点活动
      obj.isKeyActivity = this.isKeyActivity;
      // 活动投放位置
      obj.placementPosition = this.placementPosition.join(",");
      // 分享
      obj.ruleDTO.shareTitle = this.ruleDto.shareTitle;
      obj.ruleDTO.shareIntroduce = this.ruleDto.shareIntroduce;
      obj.ruleDTO.sharePic = this.ruleDto.sharePic;
      obj.ruleDTO.applyTimeStart = this.ruleDto.applyTimeStart;
      obj.ruleDTO.applyTimeEnd = this.ruleDto.applyTimeEnd;
      // 试用报告
      obj.questions =
        this.trialReport.questions.length > 0
          ? this.trialReport.questions.map((item, index) => {
              item.sort = index + 1;
              return item;
            })
          : [];
      obj.ruleDTO.isCollectTrial = this.trialReport.isCollectTrial;
      obj.ruleDTO.isReportDisplayC = this.trialReport.isReportDisplayC;
      obj.ruleDTO.plusObject = this.ruleDto.plusObject;
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem;
      obj.itemList = this.itemListFor; //曝光商品集合
      obj.templateId = this.templateId;
      let jsonStr = {
        ...this.customerPaperwork,
        activityTheme: this.ruleDto.activityTheme,
        activityRemark: this.ruleDto.activityRemark,
        textColor: this.ruleDto.textColor,
        shopNameType: this.ruleDto.shopNameType,
        moreActSet: this.ruleDto.moreActSet,
      };
      obj.ruleDTO.customerPaperwork = JSON.stringify(jsonStr);
      // V2.5 => 复制，去除id和旧的模板数据
      // if (this.activityData.isCopy) {
      //   delete obj.templateJson;
      // }
      if (this.checked == true || this.isDraft) {
        if (this.activityData.isStart) {
          let params = {
            ...obj,
            activityId: this.valueRow.id,
            ruleDto: obj.ruleDTO,
            prizes: obj.pointActivityPrizeDTOList.map((item) => {
              return {
                ...item,
                prizeId: item.id,
              };
            }),
          };
          delete params.ruleDTO
          delete params.pointActivityPrizeDTOList
          // if (this.actEndTime != this.ruleForm.endTime) {
          //   params.endTime = this.ruleForm.endTime;
          // }
          updateCommon(params)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          // 草稿箱
          if (this.isDraft) {
            obj.status = 5;
          } else {
            if (obj.status) {
              delete obj.status;
            }
            if (!this.activityData.isCopy && !this.isDraftEdit) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.id = this.valueRow.id;
              }
            }
          }
          if (this.valueRow && this.valueRow.status == 1) {
            obj.activityId = this.valueRow.id;
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
          }
          if (this.activityData.isCopy) {
            delete obj.id;
          }
          // 检查是否有实物管理奖品
          let hasGoodManage = this.ruleForm.pointActivityPrizeDTOList.some(item => item.isGoodManage === 1);
          obj.isGoodManage = hasGoodManage ? 1 : 0;
          let res;
          res = await createTrialActivity(obj);
          if (res && res.code == 1) {
            if (this.isDraft) {
              this.$message.success("保存成功！");
              this.$emit("returnBack", true);
            } else {
              this.joinBlackList = false;
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
              this.$message.success(res.message);
            }
          } else {
            this.$message.error(res.message);
          }
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        getTrialActivityDetail(this.valueRow.id)
          .then((res) => {
            const {
              activityName,
              allowLevel,
              crowdIds,
              ruleDto,
              questions,
              pointActivityPrizeDTOList,
              ruleDescription,
              isExposureItem,
              itemList,
              priceType,
              startTime,
              endTime,
              condFollow,
              studentSatus,
            } = res.data;
            const {
              firstOpenCardTimeType,
              openCardStartTime,
              openCardEndTime,
              plusObject,
              isCollectTrial,
              isReportDisplayC,
              winningListType,
              customerPaperwork,
              shareTitle,
              shareIntroduce,
              sharePic,
              applyTimeStart,
              applyTimeEnd,
              openCardBeforeDay,
              openCardFollow
            } = ruleDto;
            // 活动名称
            this.ruleForm.activityName = (
              activityName + (this.activityData.isCopy ? "复制" : "")
            );
            // 活动对象
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds ? crowdIds.split(",") : [];
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            // 关注店铺后方可参与互动
            this.ruleForm.condFollow = Boolean(condFollow);
            // 黑名单
            this.ruleForm.isValidBlackList = res.data.isValidBlackList;
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            // 试用反馈
            this.trialReport.questions = questions ? questions : [];
            this.ruleForm.pointActivityPrizeDTOList =
              pointActivityPrizeDTOList && pointActivityPrizeDTOList.length
                ? pointActivityPrizeDTOList
                : [];
            if (this.ruleForm.pointActivityPrizeDTOList.length) {
              this.ruleForm.pointActivityPrizeDTOList.map((el) => {
                el.rewardWayPreview = this.calcRewardWay(el);
                // 如果 trialConsumeAmount 有值，自动勾选 onlyConsumeUser
                if (el.trialConsumeAmount) {
                  el.onlyConsumeUser = true;
                }
              });
            }

            this.trialReport.isCollectTrial = isCollectTrial;
            this.trialReport.isReportDisplayC = isReportDisplayC;
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType || 0;
            this.ruleDto.openCardStartTime = openCardStartTime;
            this.ruleDto.openCardEndTime = openCardEndTime;

            if(openCardStartTime&&openCardEndTime) {
              this.ruleForm.firstOpenCardTimeType = 2;
            }
            this.ruleForm.openCardBeforeDay = openCardBeforeDay || "";
            this.ruleForm.openCardFollow = openCardFollow || 0;

            this.ruleDto.plusObject = plusObject;
            this.ruleDto.winningListType = winningListType;
            let jsonObj = JSON.parse(customerPaperwork);
            this.customerPaperwork = jsonObj;
            this.ruleDto.shopNameType = jsonObj.shopNameType || 0;
            this.ruleDto.moreActSet = jsonObj.moreActSet || {
              isShowFloatWindow: 0,//是否显示活动浮窗：0-不显示，1-显示
              floatWindowImg: "",//活动浮窗图片
              goShopSetting: 0,//活动浮窗跳转设置
              goShopAppId: "",//活动浮窗跳转小程序ID
              goShopUrl: "",//活动浮窗跳转链接
              isShowBanner: 0,//是否显示活动banner：0-不显示，1-显示
              bannerList: [],//banner列表
            };
            // 活动标题
            this.ruleDto.activityTheme = jsonObj.activityTheme;
            // 活动说明
            this.ruleDto.activityRemark = jsonObj.activityRemark;
            // 标题文字颜色
            this.ruleDto.textColor = jsonObj.textColor;
            // 自定义背景图
            if(res.data.templateId) {
              this.templateId = res.data.templateId;
            } else if (res.data.templateJson) {
              this.templateId = JSON.parse(res.data.templateJson).id;
            }
            this.ruleDto.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON;
            this.ruleDto.isForceRemind = res.data.ruleDto.isForceRemind;
            // 是否重点活动
            this.isKeyActivity = res.data.isKeyActivity || 0;
            // 活动投放位置
            this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
            // 分享
            this.ruleDto.shareTitle = shareTitle;
            this.ruleDto.shareIntroduce = shareIntroduce;
            this.ruleDto.sharePic = sharePic;
            this.ruleForm.ruleDescription = ruleDescription;
            // 曝光商品
            this.ruleForm.priceType = priceType; // 0：显示京东价 1：显示促销价 ,
            this.ruleForm.isExposureItem = isExposureItem;
            this.selectGoodsArr = itemList;
            this.mainImagelist = itemList;
            this.itemListFor = itemList;
            this.ruleForm.startTime = startTime;
            this.ruleForm.endTime = endTime;
            this.ruleDto.applyTimeStart = applyTimeStart;
            this.ruleDto.applyTimeEnd = applyTimeEnd;
            this.actEndTime = endTime;
            if (this.activityData.isCopy) {
              this.ruleForm.startTime = this.$getDate(30)[0];
              this.ruleForm.endTime = this.$getDate(30)[1];
              this.ruleForm.ruleDescription = "";
            }
            this.activityTimeChange();
          })
          .catch((res) => {});
      } else {
        // 新增-默认活动时间
        if (!this.valueRow) {
          this.ruleForm.startTime = this.$getDate(30)[0];
          this.ruleForm.endTime = this.$getDate(30)[1];
          this.getApplyTime();
        }
        this.activityTimeChange();
      }
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
      this.activityTimeChange();
    },
    clearApplyTime() {
      this.ruleDto.applyTimeStart = "";
      this.ruleDto.applyTimeEnd = "";
    },
    // 活动时间改变
    activityTimeChange(e, type) {
      this.$nextTick(() => {
        let nowTime = new Date().getTime();
        let start = new Date(this.ruleForm.startTime).valueOf();
        let end = new Date(this.ruleForm.endTime).valueOf();
        let invalidateDate = new Date(
          this.$store.getters.pointUserInfo.expiredIn
        ).valueOf();
        let hdInvalidateDate = new Date(
          this.$store.getters.loginUserInfo.expiresIn
        ).valueOf();
        if (this.ruleForm.endTime && this.ruleForm.startTime) {
          this.timeDay = Math.floor(
            Math.abs(
              new Date(this.ruleForm.endTime) -
                new Date(this.ruleForm.startTime)
            ) /
              1000 /
              60 /
              60 /
              24
          );
          //计算小时
          const date3 =
            new Date(this.ruleForm.endTime).getTime() -
            new Date(this.ruleForm.startTime).getTime();
          const leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          // 查看不需要校验
          if (!this.backgroundOpacity) {
            if (start < nowTime) {
              if (this.valueRow && this.valueRow.id) {
                this.disableTime = true;
              }
            }
          }
        } else {
          this.timeDay = 0;
          this.timeOut = 0;
        }
        if (type == 1 || !e) {
          if (start > invalidateDate) {
            this.$message.warning("活动时间不能超过软件有效期，请重新选择");
            this.ruleForm.startTime = null;
            return;
          }
          if (start > hdInvalidateDate) {
            this.$message.warning("活动时间不可超过互动数据授权有效期！");
            this.ruleForm.startTime = null;
            return;
          }
        }
        if (type == 2 || !e) {
          if (end > invalidateDate) {
            this.$message.warning("活动时间不能超过软件有效期，请重新选择");
            this.ruleForm.endTime = null;
            return;
          }
          if (end > hdInvalidateDate) {
            this.$message.warning("活动时间不可超过互动数据授权有效期！");
            this.ruleForm.endTime = null;
            return;
          }
        }
      });
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 收集题目
    collectQuestion(question) {
      this.trialReport.questions = question;
    },
    // 添加试用商品
    addProduct() {
      if (this.ruleForm.pointActivityPrizeDTOList.length == 5) {
        this.$message.warning("最多可以添加5个试用商品！");
        return;
      }
      this.trialData = {
        logo: "",
        title: "",
        tryWay: 0,
        rewardWay: 2,
        rewardFlag: 0,
        personNumOnePrize: "",
        minPersonNum: "",
        addressFillEndTime: "",
        totalAmount: null,
        awardTime: "",
        reasonFillFlag: false,
        prizeType: null,
        price: null,
        logo: null,
        title: "",
      };
      this.trialSelectDialogVisible = true;
    },
    // 试用商品保存回调
    trialSelectDone(data) {
      console.log(data,'data');
      if (this.editSelectIndex != null) {
        this.ruleForm.pointActivityPrizeDTOList[this.editSelectIndex] = data;
        this.editSelectIndex = null;
        this.trialSelectDialogVisible = false;
        return;
      } else {
        this.ruleForm.pointActivityPrizeDTOList.push(data);
      }
      this.trialSelectDialogVisible = false;
    },
    moveElement(array, index, direction) {
      if (direction === "top" && index > 0) {
        array.splice(index - 1, 0, array.splice(index, 1)[0]);
      } else if (direction === "bottom" && index < array.length - 1) {
        array.splice(index + 1, 0, array.splice(index, 1)[0]);
      }
    },
    // 上移
    trialTop(index) {
      if (this.backgroundOpacity || this.activityData.isStart) return;
      this.moveElement(this.ruleForm.pointActivityPrizeDTOList, index, "top");
    },
    // 下移
    trialBottom(index) {
      if (this.backgroundOpacity || this.activityData.isStart) return;
      this.moveElement(
        this.ruleForm.pointActivityPrizeDTOList,
        index,
        "bottom"
      );
    },
    trialEdit(index) {
      if (this.backgroundOpacity || this.activityData.isStart) return;
      this.editSelectIndex = index;
      this.trialData = this.ruleForm.pointActivityPrizeDTOList[index];
      this.trialSelectDialogVisible = true;
    },
    trialRemove(index) {
      if (this.backgroundOpacity || this.activityData.isStart) return;
      this.ruleForm.pointActivityPrizeDTOList.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.prosi {
  position: absolute;
  bottom: 107px;
  right: 38px;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #2768ff;
            border-bottom: 1px solid #2768ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #2768ff;
            border-left: 1px solid #2768ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #2768ff;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #2768ff;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #2768ff;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #2768ff;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #2768ff;
      color: #2768ff;
      transition: all 0.2s;
      &:hover {
        background-color: #2768ff;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #2768ff;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    /deep/ .el-table .el-table__header-wrapper th .cell {
      text-align: center;
      font-weight: 500;
    }
    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
    /deep/ .el-table--enable-row-transition .el-table__body td {
      text-align: center;
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #2768ff;
        border-bottom: 1px solid #2768ff;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #2768ff;
        border-left: 1px solid #2768ff;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      // font-family: system-ui;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    display: flex;
    left: 0;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #2768ff;
      background: rgba(123, 97, 255, 0.1);
      border: 1px solid #2768ff;
      &:hover {
        color: #fff;
        background: #2768ff;
      }
    }
    .reset {
      color: #2768ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
.setting-tip {
  margin: 30px 0px 20px 0px;
  &-red {
    color: red;
  }
  &-last-wrap {
    line-height: normal;
  }
}
.setting-radio {
  margin-bottom: 20px;
}
.setting-level {
  display: flex;
  align-items: center;
  &-item {
    width: 125px;
    text-align: center;
    background-color: #e9effc;
    &__active {
      color: #fff;
      background-color: #2768ff;
    }
  }
}
.btn-wrap {
  display: flex;
  align-items: center;
}
.add_btn1 {
  cursor: pointer;
  color: #2768ff;
  border: 1px solid #2768ff;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.del_box {
  position: absolute;
  left: 200px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
}
.margin-t16 {
  margin-top: 16px;
}

.rule-tip {
  margin-top: 8px;
}
.act-tip {
  white-space: nowrap;
  color: #ff0000;
}
.trialdatalist {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.active-width {
  width: 550px;
}
.trialdata {
  background: #f8f9ff;
  border-radius: 16px;
  padding: 16px;
  // width: 487px;
  width: 650px;
  min-height: 282px;

  .label {
    color: #777777;
  }

  .trialdataitem {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 8px;

    .name {
      max-width: 230px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .trbuttons {
      display: flex;
      flex: 1;
      justify-content: flex-end;
      gap: 4px;
      .trbutton {
        width: 50px;
        height: 24px;
        background: #ffffff;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #dcdfe6;
        padding: 2px;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        cursor: pointer;
        text-align: center;
      }
      .trbutton1 {
        width: auto;
        height: 24px;
        background: #ffffff;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #dcdfe6;
        padding: 2px;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        cursor: pointer;
        text-align: center;
      }
      .disabled {
        color: #c0c8d9;
        background-color: #f5f7fa;
      }
    }
  }
}
.grey-style {
  color: #ccc;
}
.ml12 {
  margin-left: 12px;
}
</style>
<style lang="scss">
.createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
</style>
